import KsIpInput from '../KsIpInput/index.vue';
import KsSelect from '../KsSelect/index.vue';
import Vue from 'vue';

function ip2int(ip) {
    var num = 0;
    ip = ip.split(".");
    num = Number(ip[0]) * 256 * 256 * 256 + Number(ip[1]) * 256 * 256 + Number(ip[2]) * 256 + Number(ip[3]);
    num = num >>> 0;
    return num;
}

export default {
    components: {
        KsIpInput,
        KsSelect
    },
    props: {
        value: {
            default: '',
            type: String,
            require: true
        },
        dhcpFrom: {
            default: '',
            type: String,
            require: true
        },
        dhcpTo: {
            default: '',
            type: String,
            require: true
        },
        ipOptions: {
            default: () => [],
            type: Array,
            require: true
        },
        alertEnable: {
            default: true,
            type: Boolean,
            require: false
        },
        defaultAuto: {
            type: Boolean,
            required: false,
            default: false
        },
        defaultIp: {
            type: Boolean,
            required: false,
            default: false
        },
        ipCount: {
            type: Number,
            required: false,
            default: 0
        },
        legalIp: {
            type: Boolean,
            required: false,
            default: true
        },
        autoIp: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            ip: '0.0.0.0',
            selectedOption: '',
            options: [],
            filterOptions: [],
            selected: false,
            illegalIp: '',
            disabled0: false,
            disabled1: false,
            disabled2: false,
            disabled3: false,
            emptyTemple: {
                title: '无可用IP',
                value: '0.0.0.0',
                disabled: true
            },
            showIpAlert: false,
            showDHCPAlert: false,
            timer: null,
            lastIp: '',
            tipMsg: ''
        }
    },
    computed: {
        ipCountNumber() {
            if(this.dhcpFrom === '' || this.dhcpTo === '') {
                return 0
            }
            return this.options.length - this.ipOptions.length
        },
        ip2: {
            get() {
                    let result;
                    try {
                        let ip = this.ip.split('.');
                        result = ip[2]
                    } catch(e) {
                        result = ''
                    }
                    return result
            },
            set(v) {
                let ipAry = this.ip.split('.');
                this.ip = '0.0.0.0';
                this.$nextTick(()=>{
                    this.ip = `${ipAry[0]}.${ipAry[1]}.${v}.${ipAry[3]}`;
                })
            }
        },
        ip3: {
            get() {
                let result;
                try {
                    let ip = this.ip.split('.');
                    result = ip[3]
                } catch(e) {
                    result = ''
                }
                return result
            },
            set(v) {
                let ipAry = this.ip.split('.');
                this.ip = '0.0.0.0';
                this.$nextTick(()=>{
                    this.ip = `${ipAry[0]}.${ipAry[1]}.${ipAry[2]}.${v}`;
                })
            }
        }
    },
    watch: {
        value: {
            handler: function(v) {
                this.ip = v;
            }
        },
        ip: {
            handler: function(v, old) {
                this.$emit("update:legalIp",this.checkLegal());
                this.lastIp = old;
                this.$emit("input", v);
                if(!v) {
                    return
                }
                let breakCondition1 = this.ip2 === '' && this.ip3 === '',
                    breakCondition2 = this.ip === '0.0.0.0';
                if(breakCondition1 || breakCondition2 || this.setByFatherComp()) {
                    this.$nextTick(this.closeSelect);
                    // this.closeSelect()
                }
            },
        },
        ip2: _.debounce(function(v,o) {
            //允许手动设置为0.0.0.0 :) 此时不再自动修正
            if(this.ip !== '0.0.0.0') {
                let maxIp2 = this.dhcpTo.split('.')[2],
                    minIp2 = this.dhcpFrom.split('.')[2],
                    condition1 = v * 1 <= maxIp2 * 1,
                    condition2 = v * 1 >= minIp2 * 1;
                if(!condition1) {
                    this.ip2 = maxIp2;
                    return
                }
                if(!condition2) {
                    this.ip2 = minIp2;
                    return
                }
            }
            let breakCondition1 = this.selected
            let breakCondition2 = this.ip2 === '' & this.ip3 === ''
            let breakCondition3 = !this.$refs.select.open
            let breakCondition4 = this.ip === '0.0.0.0';
            let breakCondition5 = this.setByFatherComp();
            if((breakCondition1 || breakCondition2 || breakCondition4 || breakCondition5) && breakCondition3) {
                return
            }
            this.selected = false
            let parma = v === '' ? null : v
            this.computeListOption(parma,2);
            this.openSelect()
        },500),
        ip3: _.debounce(function(v,o) {
            if(this.ip !== '0.0.0.0') {
                let fromAry = this.dhcpFrom.split('.'),
                    toAry = this.dhcpTo.split('.'),
                    maxIp3 = toAry[3],
                    minIp3 = fromAry[3],
                    condition1 = this.ip2 == fromAry[2] ? v * 1 >= minIp3 * 1 : v * 1 > 1,
                    condition2 = this.ip2 == toAry[2] ? v * 1 <= maxIp3 * 1: v * 1 < 255;
                if(!condition1) {
                    this.ip3 = this.ip2 == fromAry[2] ? minIp3 : 2;
                    return
                }
                if(!condition2) {
                    this.ip3 = this.ip2 == toAry[2] ? maxIp3 : 254;
                    return
                }
            }
            let breakCondition1 = !o && o !== '';
            let breakCondition2 = this.selected;
            let breakCondition3 = this.ip2 === '' & this.ip3 === '';
            let breakCondition4 = !this.$refs.select.open;
            let breakCondition5 = this.ip === '0.0.0.0';
            let breakCondition6 = this.setByFatherComp();
            if((breakCondition1 || breakCondition2 || breakCondition3 || breakCondition5 || breakCondition6) && breakCondition4) {
                return
            }
            this.selected = false
            let parma = v === '' ? null : v
            this.computeListOption(parma,3);
            this.openSelect();
            if((o !== '' && !o) || this.lastIp === '0.0.0.0') {
                this.closeSelect()
            }
        },500),
        selectedOption: {
            deep: true,
            handler: function(v) {
                this.ip = v.value;
                this.$emit("input", v.value);
                this.closeSelect();
                this.selected = true;
                this.$emit('update:autoIp',false);
            }
        },
        dhcpFrom(v,o) {
            this.init();
        },
        dhcpTo(v,o) {
            this.init();
        },
        ipOptions() {
            this.init();
        },
        ipCountNumber() {
            this.$emit("update:ipCount",this.ipCountNumber);
        },
        defaultAuto(v) {
            if(v) {
                this.setAuto();
                this.$emit('update:legalIp',true);
            }
        },
        defaultIp(v) {
            if(v) {
                this.setDefault();
            }
        }
    },
    methods: {
        init() {
            this.computeDisable();
            this.generateList();
            if(this.defaultIp) {
                this.setDefault();
            }
            this.computeListOption(null,3);
            if(this.defaultAuto) {
                this.setAuto();
                this.$emit('update:legalIp',true);
            }
        },
        computeDisable() {
            let allDisableCondition1 = this.dhcpTo === '' || this.dhcpFrom === '',
                allDisableCondition2 = !this.dhcpFrom || !this.dhcpTo;
            if(allDisableCondition1 || allDisableCondition2) {
                this.disabled0 = true;
                this.disabled1 = true;
                this.disabled2 = true;
                this.disabled3 = true;
                return
            }
            let minAry = this.dhcpFrom.split('.'),
                maxAry = this.dhcpTo.split('.');
            this.disabled0 = minAry[0] === maxAry[0];
            this.disabled1 = minAry[1] === maxAry[1];
            this.disabled2 = minAry[2] === maxAry[2];
            this.disabled3 = minAry[3] === maxAry[3];
        },
        generateList() {
            this.options = [];
            let minAry = this.dhcpFrom.split('.'),
                maxAry = this.dhcpTo.split('.'),
                i = 2,
                result = [],
                listOptions = [],
                a = minAry[0],
                b = minAry[1],
                c = minAry[2],
                d = minAry[3];
            for( i ; i < 4 ; i++ ) {
                if(minAry[i] !== maxAry[i]) {
                    break;
                }
            }
            //根据dhcp生成列表
            //todo
            if(i === 2) {
                let maxC = maxAry[2] * 1;
                for(let c = (minAry[2] * 1) ; c <= 255 ; c++ ) {
                    if(c > maxC) {
                        break;
                    }
                    let lastMaxD = maxAry[2] == c ? maxAry[3] * 1 : 254;
                    for(let d = 1 ; d <= lastMaxD ; d++ ) {
                        result.push(`${a}.${b}.${c}.${d}`);
                    }
                }
            }
            if(i === 3) {
                let maxD = maxAry[3] * 1 ,
                    // d = minAry[3] * 1 >= 2 ? minAry[3] * 1 : 2;
                    d = _.toNumber(minAry[3]) || 1;
                for(; (d <= maxD && d < 255) ; d++ ) {
                    result.push(`${a}.${b}.${c}.${d}`);
                }
            }
            result =  _.difference(result,this.ipOptions);
            _.each(result, ip => {
                listOptions.push({
                    title: ip,
                    value: ip,
                });
            })
            _.each(this.ipOptions, ip => {
                listOptions.push({
                    title: `${ip}（已被分配）`,
                    value: ip,
                    disabled: true
                })
            })
            if(listOptions.length === 0) {
                listOptions.push(this.emptyTemple)
            };
            this.options = listOptions;
        },
        computeListOption(v, poi) {
            if(this.ip2 === '' && this.ip3 === '') {
                return
            }
            let me = this,
                currentIpAry = me.ip.split('.'),
                dhcpFromAry = currentIpAry,
                filterFunctions = {
                    2 : function(ip) {
                            let result = false;
                            try {
                                let target2 = ip.value.split('.')[2],
                                    target3 = ip.value.split('.')[3],
                                    value2 = currentIpAry[2],
                                    value3 = currentIpAry[3]
                                return v ? (target2 === v && target2 === value2) : target3 === value3
                            } catch(e) {
                                return false;
                            }
                            return true
                        },
                    3 : function(ip) {
                            let result = false;
                            try {
                                let target2 = ip.value.split('.')[2],
                                    target3 = ip.value.split('.')[3],
                                    value2 = currentIpAry[2],
                                    value3 = currentIpAry[3];
                                let condition1 = target2 === value2
                                let condition2 = target3 === value3
                                let condition = v ? (condition1 && condition2) : condition1
                                return condition
                            } catch(e) {
                                return false;
                            }
                            return true
                        }
                };
                let filtedAry = _.filter(this.options, filterFunctions[poi]);
                this.filterOptions = filtedAry.length !== 0 ? filtedAry : [this.emptyTemple];
                if(filtedAry.length === 0) {
                    this.$emit("fail");
                }
        },
        checkLegal() {
            let escapeCondition1 = this.ip === '0.0.0.0' || this.ip === '';
            if(escapeCondition1) {
                // this.$emit('fail');
                return true
            }
            let condition1 = !this.checkDisableLegal(),
                condition2 = !this.checkDHCPLegal();
            if(condition1) {
                this.alertHandler(1);
                return false
            }
            if(condition2) {
                this.alertHandler(2);
                return false
            }
            this.showIpAlert = false;
            this.showDHCPAlert = false;
            return true
        },
        alertHandler(type) {
            this.$emit('fail');
            this.showIpAlert = false;
            this.showDHCPAlert = false;
            let me = this,
                handler = {
                    //debounced
                1 : function() {
                    let target = _.find(me.filterOptions, item => item.value === me.ip) || {};
                    me.illegalIp = target.value;
                    me.showIpAlert = true;
                },
                2 : function() {
                    me.showDHCPAlert = true;
                    me.illegalIp = me.ip;
                },
            }[type];
            handler();
            clearTimeout(this.timer);
            this.timer = setTimeout(()=>{
                this.showIpAlert = false;
                this.showDHCPAlert = false;
            },5000);
        },
        checkDisableLegal() {
            // let target = _.find(this.filterOptions, item => item.value === this.ip) || {};
            let target = _.find(this.options, item => item.value === this.ip) || {};
            return !target.disabled
        },
        checkDHCPLegal() {
            if(this.ip2 === '' || this.ip3 === '' || this.dhcpFrom === '' || this.dhcpTo === '') {
                return true
            }
            let dhcpFromNumber = ip2int(this.dhcpFrom);
            let dhcpToNumber = ip2int(this.dhcpTo);
            let ip = ip2int(this.ip);
            let ipAry = this.ip.split('.');
            return ip >= dhcpFromNumber && ip <= dhcpToNumber
                && ipAry[3] != 0
                // && ipAry[3] != 1
                && ipAry[3] != 255;
        },
        setAuto() {
              let minAry = this.dhcpFrom.split('.'),
                maxAry = this.dhcpTo.split('.'),
                i = 2,
                a = minAry[0],
                b = minAry[1],
                c = minAry[2],
                d = minAry[3];
            for( i ; i < 4 ; i++ ) {
                if(minAry[i] !== maxAry[i]) {
                    break;
                }
            }
            if(i === 2) {
                this.ip = `${a}.${b}..`;
                this.$emit("input", `${a}.${b}..`);

            } else {
                this.ip = `${a}.${b}.${c}.`;
                this.$emit("input", `${a}.${b}.${c}.`);
            }
        },
        setDefault() {
            let result = _.differenceWith(this.options,this.ipOptions,(a,b) => a.value === b),
                length = result.length,
                maxIndex = length > 0 ? --length : length,
                index = (Math.random() * maxIndex).toFixed();
            let defaultIp = _.get(result,`[${index}].value`) || '0.0.0.0';
            this.$emit("input", defaultIp);
            this.$nextTick(()=>{
                this.closeSelect();
            })
        },
        setByFatherComp() {
            let pos2 = $(".ks-server-ip .ksc-ip-input .pos-2").is(':focus'),
                pos3 = $(".ks-server-ip .ksc-ip-input .pos-3").is(':focus');
            if(!pos2 && !pos3) {
                return true
            }
        },
        openSelect() {
            this.$refs.select.open = true;
            $(document).trigger('ks-select-click', [this.$refs.select.uuid]);
        },
        closeSelect() {
            this.$refs.select.open = false;
        },
        clickHandler(e) {
            e.stopPropagation();
            let className = e.target.className
            if(className.indexOf('pos-2') !== -1 || className.indexOf('pos-3') !== -1) {
                let parma = className === 'pos-2' ? 2 : 3
                this.computeListOption(null,parma)
                this.openSelect();
            }
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.computeDisable();
        this.generateList();
        this.closeSelect();
    }
}
